import React from 'react';
import styled from 'styled-components';
import { RichH2, RichP1 } from '../Typography';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
import { getParsedField } from '../../utils/helpers';
const Container = styled.header `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 81px 40px 58px;
  text-align: center;
  background-color: ${({ theme }) => theme.primaryWhite};

  ${media.mobile} {
    padding: 30px 20px 10px;
  }

  *:last-child {
    margin-bottom: 0px;
  }
`;
const Title = styled(RichH2) `
  max-width: 920px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.trueBlack};
`;
const Subtitle = styled(RichP1) `
  max-width: 920px;
  color: ${({ theme }) => theme.trueBlack};
`;
export const ComponentHeader = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { componentSubtitle, componentTitle } = fields;
    const parsedTitle = getParsedField(componentTitle);
    const parsedSubtitle = getParsedField(componentSubtitle);
    return (
    //need this className as css styles can be aplied to it inside other components, like in case with CardGridContainer
    React.createElement(Container, { className: "header-container" },
        isFieldValid(componentTitle) && React.createElement(Title, { field: parsedTitle }),
        isFieldValid(componentSubtitle) && React.createElement(Subtitle, { field: parsedSubtitle })));
};
